import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from "google-maps-react";
import Select from "react-select";
import { gender } from "../config/data";
import InputField from "../components/UI/InputField";

import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";
import {
  searchBusiness,
  getClientFamilyDetails,
  getdoctordetails,
} from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';
import FooterWeb from './Footerweb';
import Headerweb from './Headerweb';
import SimpleSlider from './Simpleslider';
import LogoSlider from './LogoSlider';
import Topmove from './Topmove';
import Whatsapp from './Whatsapp';
import Chatbox from './Chatbox';
import Webadslider from './Webadslider';
import Webblog from './Webblog';
import AdPopUp from './AdPopUp';
import HealthChatbot from './HealthChatbot';
import Webbenifits from './Webbenifits';
import ManagmentSlider from './ManagmentSlider';
import HospitalSearch from './HospitalSearch';
import { Helmet } from 'react-helmet';
const mapStyles = {
  width: "100%",
  height: "100%",
};

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
        searchData: state.SearchReducer.searchData,
    userdata: state.AuthReducer.user,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
        setSearchData: (data) => dispatch({ type: "SET_SEARCH_DATA",payload:data})
    };
}
function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      resolve(false)
    }
    document.body.appendChild(script)
  })
}

class Home extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
         
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            visible: false,
            records:[],
            showMore: false,
            staticText: [
              "The Digital Health Revolution Starts Here.",
              
              "Imagine a world where healthcare fits seamlessly into your life. No more endless phone calls, frustrating paperwork, or wasted hours in waiting rooms. KlinicQ is your gateway to a streamlined, empowering healthcare experience. Our cutting-edge, cloud-based Electronic Clinical Management System (ECMS) puts the power of personalized healthcare right at your fingertips,"
          ],
            typingWords: ["Anytime.", "Anywhere."],
            displayedText: '',
            index: 0,
            isTyping: true,
            isErasing: false,
            currentWordIndex: 0,
                  // queuein_data: [],
                  loading: false,
                  business_list: [],
                  business_name: "",
                  latitude: "",
                  longitude: "",
                  bookModel : false,
                 // IsNext:false,
           
            
                  
                  searchErrorMessage: "",
                  //   category: this.props.appdata.category,
                
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
        
       

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();
        this.props.history.push("/");

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
        this.props.history.push("/");
      }
    }

 
    componentDidMount = () => {
      /*    console.log(this.props.userdata.user_type);
         axios.defaults.headers.common[
             "Authorization"
         ] = `Bearer ${this.props.access_token}`;
 
         axios
             .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
             .then((res) => {
                 let data = res.data;
                 console.log(res);
                 console.log(data);
                 console.log(data.data.timeout);
                 if (data.status === "1")
                     this.setState({
                         hospitaltimeout: data.data.timeout
 
                     });
             })
             .catch((e) => { }); */
             this.type();
             
     }
     type = () => {
      const { typingWords, currentWordIndex, displayedText, isTyping } = this.state;

      if (isTyping) {
          if (this.state.index < typingWords[currentWordIndex].length) {
              this.setState(prevState => ({
                  displayedText: prevState.displayedText + typingWords[currentWordIndex].charAt(prevState.index),
                  index: prevState.index + 1,
              }));
              setTimeout(this.type, 100); // Adjust typing speed here (in milliseconds)
          } else {
              // Switch to erasing mode after typing is complete
              this.setState({ isTyping: false });
              setTimeout(this.erase, 1000); // Wait before starting to erase
          }
      }
  };

  erase = () => {
      const { typingWords, currentWordIndex, displayedText } = this.state;

      if (this.state.index > 0) {
          this.setState(prevState => ({
              displayedText: prevState.displayedText.slice(0, -1),
              index: prevState.index - 1,
          }));
          setTimeout(this.erase, 100); // Adjust erasing speed here (in milliseconds)
      } else {
          // Move to the next word
          this.setState(prevState => ({
              isTyping: true,
              currentWordIndex: (prevState.currentWordIndex + 1) % typingWords.length,
              index: 0,
              displayedText: '',
          }));
          setTimeout(this.type, 500); // Wait before starting to type the next word
      }
  };
 
 openWidget = () => {
  if (window.tars && window.tars.open) {
    window.tars.open();
  }
};


  componentWillUnmount() {
      clearTimeout(this.timer);
      
  }
  

  handleInput = (e) => {
    let data = this.state.searchData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    data[name] = value;
    if (
      name === "doctor_name" ||
      name === "city"

    ) {
      this.validateMaxLength(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ searchData: data });

  };
  validateMaxLength(name, value, max) {
    let data = this.state.searchData;
    let errors = this.state.errors;

    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      errors[name] = "";
      data[name] = value;
    }
    this.setState({ searchData: data, errors: errors });
  }


   handleDistanceChange = (event) => {
    let data = this.state.searchData;
    data.distance = event.target.value;
    this.setState({ searchData: data });
  };
  handleTimingSelect = (event) => {
    let data = this.state.queuein_data;
    let errors=this.state.errors;
    data.n_schedule_day_id = event.target.value;
    errors.n_schedule_day_id="";
    this.setState({ queuein_data: data });
  };
 

 
   clearSearchData = () => {
      var searchData = this.state.searchData;
      let searchErrorMessage=this.state.searchErrorMessage;
      searchData.business_name = "";
      searchData.doctor_name = "";
      searchData.facility = "";
      searchData.speciality = "";
      searchData.gender = "";
      searchData.city = "";
      searchData.distance = 5;
      searchData.distance_type = "KM";
      this.props.setSearchData(searchData);
      this.setState({  searchErrorMessage:""  });
      this.setState({ searchData: searchData,
        searchresults:{
          data: [],
        } 
      });
      searchData.reviews = 0;
     // this.getData();
      this.getmyLocation();
    };


    toggleContent = () => {
      this.setState(prevState => ({
        showMore: !prevState.showMore,
      }));
    };

     displayMarkers = () => {
        let mapImage = require("../assets/images/map-pin.png")
        let iconMarker = new window.google.maps.MarkerImage(
          mapImage,
          null /* size is determined at runtime */,
          null /* origin is 0,0 */,
          null /* anchor is bottom center of the scaled image */,
          new window.google.maps.Size(100, 100)
        );
        return this.state.searchresults
          ? this.state.searchresults.data.map((business, index) => {
            //This need to replcae real waiting time from queue table
    
    
          
           let waitingtime = business.expected_wait_time
            //  console.log(waitingtime)
            // if (!before30min) {
            return (
              <Marker
                key={index}
                id={index}
                name={business.business_name}
                position={{
                  lat: business.latitude,
                  lng: business.longitude,
                }}
                label={{
                  text: waitingtime,
                  color: "black",
                  fontSize: "20px",
                }}
                cursor="pointer"
                disableDefaultUI={true}
                icon={iconMarker}
                onClick={this.showFamilydetail.bind(this, business)}
              />
            );
            // }
    
          })
          : "";
      };
    
    render() {
      
        return (

<div className=''>
      <Headerweb />
       <Helmet>
    <title>KlinicQ - Clinic & Hospital Management Software</title>
    <meta 
        name="description" 
        content="KlinicQ is a cloud-based clinic & hospital management system with EMR, appointments, pharmacy & billing. Streamline your entire healthcare practice with ease." 
    />

 

    {/* 1. Organization Schema */}
    <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "KlinicQ",
      "url": "https://klinicq.com",
      "logo": "https://klinicq.com/logo.png", // Ensure this is a direct absolute URL
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-XXXXXXXXXX", // Add your contact
        "contactType": "customer service"
      },
      "description": "Cloud-based clinic and hospital management software",
      "sameAs": [
        "https://facebook.com/klinicq", // Add your social links
        "https://linkedin.com/company/klinicq"
      ]
    })}
    </script>

    {/* 2. WebSite Schema (Crucial for Home Page) */}
    <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": "https://klinicq.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://klinicq.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    })}
    </script>

    {/* 3. SoftwareApplication Schema */}
    <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "KlinicQ",
      "applicationCategory": "HealthApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "INR"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "120"
      }
    })}
    </script>

    {/* 4. FAQ Schema (Expanded for better visibility) */}
    <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is KlinicQ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KlinicQ is a cloud-based clinic and hospital management system providing EMR, scheduling, and billing solutions."
          }
        },
        {
          "@type": "Question",
          "name": "Does KlinicQ offer a mobile app for doctors?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, KlinicQ is built for accessibility on both web and mobile browsers for seamless healthcare management."
          }
        }
      ]
    })}
    </script>
    {/* 5. Breadcrumb Schema */}
<script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://klinicq.com"
    }
  ]
})}
</script>
</Helmet>

      <section className='position-relative section-start'>
         <section class="hero-section">
            <div class="hero-background">
               <img 
                src={require("../../src/assets/images/website/Mask-group-optimized.webp")} 
                alt="Background pattern" 
                className="hero-bg-main" 
                fetchPriority="high"
                loading="eager"
                width="457"  // Always add these to prevent layout shift
                height="525" 
              />
            </div>
            
            <div class="hero-content">
                <h1 class="">KlinicQ is a renowned clinic providing <br/> exemplary online medical treatment services.</h1>
                <p class="">leading clinic offering exceptional online medical treatment services,<br /> ensuring convenient and expert care from the comfort of home.</p>
            </div>

            <div class="testimonial-card">
                <div class="testimonial-avatars">
                    <img src={require("../../src/assets/images/website/img_ellipse_306.webp")} alt="Customer avatar" class="avatar" />
                    <img src={require("../../src/assets/images/website/img_ellipse_306.webp")} alt="Customer avatar" class="avatar" />
                    <img src={require("../../src/assets/images/website/img_ellipse_305.webp")} alt="Customer avatar" class="avatar" />
                    <img src={require("../../src/assets/images/website/img_ellipse_304.webp")} alt="Customer avatar" class="avatar" />
                </div>
                <div class="testimonial-divider"></div>
                <img src={require("../../src/assets/images/website/support3.webp")} alt="Google" class="google-icon" />
                <div class="testimonial-content">
                    <div class="testimonial-title">Take Our Support</div>
                    <img src={require("../../src/assets/images/website/img_group_8751.webp")} alt="5 star rating" class="testimonial-stars" />
                </div>
                <a class="demo-button" href="/" aria-label="Play demo video">
                <img src={require("../../src/assets/images/website/img_frame.webp")} alt="Play" class="demo-icon" />
            </a>
            </div>

            <img src={require("../../src/assets/images/website/smilingfemaledoctors.webp")} alt="Smiling female doctor" class="doctor-image" />
            <img src={require("../../src/assets/images/website/img_001_copy_2.webp")} alt="Mobile app interface" class="phone-image" />

            <div class="cta-buttons">
               <button className="schedule-btn" onClick={this.openWidget}>
  <span className="schedule-text">AI Assistant</span>
</button>

               <a href="https://www.youtube.com/watch?v=qPbaZgYzeYs" target="_blank" rel="noopener noreferrer">
    <button class="play-btn" onclick="playDemo()" aria-label="Play demo">
        <img src={require("../../src/assets/images/website/img_frame_white_a700.webp")} alt="Play" class="play-icon" />
    </button>
</a>

                <span class="demo-text">See demo</span>
            </div>
        </section>

        <ManagmentSlider />

        <div className='profile-section ps-lg-5 ps-0'>
        <HospitalSearch />
        </div>
    
        <Webbenifits />

        <div className='rest-section py-0'>
          <div className='container-90'>
            <div className='row m-0 align-items-center'>
              <div className='col-lg-6 col-12 text-end position-relative slide-right visible'> 
                <img src={require("../../src/assets/images/website/rest3.webp")} className='rest3 w-65' alt="available" loading="lazy" srcSet={`${require("../../src/assets/images/website/rest3.webp")} 1x, ${require("../../src/assets/images/website/rest3-small.webp")} 0.5x`} />
                <div className='available'>
                  <div className='d-flex align-items-center p-lg-3 p-md-3 p-1 '>
                    {/* <FontAwesomeIcon icon={faCircleDot} beat style={{ color: '#46E826', fontSize: '20px' }} className='beat-icon' /> */}
                    {/* <i class="fa-solid fa-circle-dot"  beat style={{ color: '#46E826', fontSize: '20px' }} className='beat-icon'></i> */}
                    <div className='mar-top'>
                      <label className=''>Available Specialist</label><br />
                      <p className='mb-0 ps-3'>Select Specialist </p>
                    </div>
                  </div>
                  <div className='d-flex align-items-center p-lg-3 p-md-3 p-1'>
                    <img src={require("../../src/assets/images/website/rest4.webp")} alt="doctor-name"/>
                    <div className='doctor-name'>
                      <h2 className='ps-3'>Dr Adinda</h2>
                      <p className='mb-0 text-start ps-3'>Eye Specialist</p>
                    </div>
                  </div>
                  <div className='d-flex align-items-center p-lg-3 p-md-3 p-1'>
                    <img src={require("../../src/assets/images/website/rest5.webp")} alt="doctor-name"/>
                    <div className='doctor-name'>
                      <h2 className='ps-3'>Dr Jackson</h2>
                      <p className='mb-0 text-start ps-3'>Ear Specialist</p>
                    </div>
                  </div>
                  <div className='find-doctor text-center my-3 ml-3'>
                    <a href="/login"><button>Find Doctor <img src={require("../../src/assets/images/website/arrowup.webp")} alt="arrow up"/></button></a>
                    {/* <button>Find Doctor </button> */}
                  </div>
                </div>
              </div>
              <div className='col-lg-6 col-12 slide-left visible'>
                <h3 className=''>Your Health, Expertly Managed, Rest Assured.</h3>
                <p className=''><strong>Your Well-being, Expertly Managed:</strong> Imagine a healthcare experience designed for your peace of mind. Our advanced Clinical Management System (CMS) ensures every detail is meticulously managed, ensuring your well-being is in the most capable hands. Our advanced Clinical Management System (CMS) revolutionizes patient care by streamlining operations, automating workflows, and providing seamless access to vital information.</p>
                <p className=''><strong>Seamless Care, Advanced Technology:</strong> From digital records and efficient appointment scheduling to secure communication and integrated billing, our CMS empowers healthcare providers to focus on what matters most: delivering exceptional care. With our system, you can rest assured that your health is in the hands of professionals equipped with the most advanced tools, ensuring a smoother, more efficient, and ultimately, more reassuring healthcare journey.</p>
                <p className=''><strong>Experience the Future of Healthcare:</strong> We've harnessed the power of digital technology to create a seamless ecosystem that optimizes every aspect of patient care.</p>
                

              </div>
            </div>
          </div>
        </div>

        <div className=' py-5'>
          <div className='container-90'>
            <div className='row m-0 align-items-center'>
              <div className='col-lg-6 col-12 slide-left visible'>
                <h3 >Transform Your Hospital's Performance: Schedule a Personalized KlinicQ Demo.</h3>
                <p className=''>"Discover how KlinicQ can revolutionize your hospital's operations. Our expert team will analyze your specific needs and provide tailored solutions to maximize revenue and minimize operational costs. Schedule a demo today and experience the future of efficient and profitable healthcare management".</p>
                {/* <button type='button' className='btn_sec' onClick={booklogin}>Book Appoinment <img src={arrowup} /></button> */}
                <a href='/login'><button type='button' className='btn_sec' >Book Appoinment
                  {/* <i class="fa-solid fa-arrow-right-long ml-2" style={{color: '#FFF'}}></i>  */}
                  </button></a>
              </div>
              <div className='col-lg-6  col-12 my-lg-0 mt-4 slide-right visible'>
                <img src={require("../../src/assets/images/website/doctor_patientcall.webp")} className='w-100' alt="docotr_patientcall" loading="lazy" />
              </div>
            </div>
          </div>
        </div>


        <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
           
                         <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
    <img src={require("../../src/assets/images/website/Group76.webp")} className="foreground-image1" alt="Foreground" loading="lazy" />
</div>
            </div>
          </div>
        </div>
        <div>
          
          {/* <AdPopUp /> */}
      <Webblog />
      </div>
          
{/* <Chatbox /> */}
 <HealthChatbot /> 
        <Whatsapp />
        <Topmove />
        <FooterWeb className="qrCodeFooter" />
      </section>
      </div>
            
        );
    }
   
}
export default connect(mapStateToProps, mapDispatchToProps)(
 
  (Home)
);
